export default {"src":"/_next/static/media/AR.f6ec7ae2.svg","height":18,"width":18};